
  export default {
    middleware: ['provider', 'products', 'blog/articles', 'products/validations', 'searches/loan', 'breadcrumbs',
                 'jumbotron', 'meta-tags'],
    meta: {
      category: 'banking',
      isProviderPage: true,
      jumbotronScope: 'compare-loans.lender',
      metaTagOptions: { image: 'loans' },
      product: 'loans',
      providerBreadcrumbs: [['i18n/home', '/'], ['i18n/banking', '/money/'], ['i18n/loans', '/compare-loans/'],
                            ['i18n/lenders', '/compare-loans/lenders/', 'mobile']],
      redirectPath: '/compare-loans/lenders/',
      searchPath: 'banking/loansearches'
    },
    data () { return { slug: null }; },
    computed: {
      provider () {
        return this.$store.getters['providers/get'];
      }
    }
  };
